module.exports = __webpack_public_path__ + "img/my-center@2x.819ba1ad.png";